var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faMicrophone, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import useAuthentication from 'hooks/use-authentication';
import useLogger from 'hooks/use-logger';
import Loader from 'components/loader/loader';
import Button from 'components/button/button';
import { ButtonStyle } from 'components/button/prop-types';
import EXAM_QUERY from 'queries/get-exam-by-id.graphql';
const MicrophoneRoute = ({ children }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const logger = useLogger();
    const { getExamIdFromToken } = useAuthentication();
    const [hasAudioQuestions, setHasAudioQuestions] = useState(false);
    const [isReadyToStart, setIsReadyToStart] = useState(false);
    const [goToTakeExam, setGoToTakeExam] = useState(localStorage.getItem('goToTakeExam') === 'true');
    const { data, loading, error } = useQuery(EXAM_QUERY, {
        variables: {
            id: getExamIdFromToken(),
        },
    });
    useEffect(() => {
        if (!data) {
            return;
        }
        getIsReadyToStart();
    }, [data]);
    const getIsReadyToStart = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!data) {
            return;
        }
        const audioQuestions = data.exam.questions.some((question) => question.questionType.typeName === 'AUDIO_TYPE');
        setHasAudioQuestions(audioQuestions);
        if (audioQuestions) {
            try {
                const microphone = yield navigator.mediaDevices.getUserMedia({ audio: true });
                setIsReadyToStart(microphone.active);
            }
            catch (error) {
                logger.error(error);
                setIsReadyToStart(false);
            }
        }
        else {
            setGoToTakeExam(true);
        }
    });
    return (_jsxs(_Fragment, { children: [loading && _jsx(Loader, { isFullWith: true }, void 0), error && (_jsx("div", Object.assign({ className: "container--content container--fixed" }, { children: _jsx("h3", { children: t('GENERAL.TRY_AGAIN') }, void 0) }), void 0)), hasAudioQuestions && !goToTakeExam && (_jsxs("div", Object.assign({ className: "container--content container--fixed" }, { children: [_jsx("h2", { children: t('MICROPHONE.REQUIREMENTS') }, void 0), _jsx("p", { children: t('MICROPHONE.REQUIREMENTS_DESCRIPTION') }, void 0), !isReadyToStart && (_jsxs("div", Object.assign({ className: "card card--requirements" }, { children: [_jsxs("div", Object.assign({ className: "card--requirements__status" }, { children: [_jsx(FontAwesomeIcon, { className: "disabled", icon: faSpinner }, void 0), _jsx("span", Object.assign({ className: "disabled" }, { children: t('MICROPHONE.CHECKING') }), void 0)] }), void 0), _jsxs("div", Object.assign({ className: "card--requirements__body" }, { children: [_jsx(FontAwesomeIcon, { className: "disabled", icon: faMicrophone }, void 0), _jsx("span", Object.assign({ className: "disabled" }, { children: t('MICROPHONE.MICROPHONE_DISABLED') }), void 0)] }), void 0)] }), void 0)), isReadyToStart && (_jsxs("div", Object.assign({ className: "card card--requirements" }, { children: [_jsxs("div", Object.assign({ className: "card--requirements__status" }, { children: [_jsx(FontAwesomeIcon, { className: "enabled", icon: faCheckCircle }, void 0), _jsx("span", { children: t('MICROPHONE.READY') }, void 0)] }), void 0), _jsxs("div", Object.assign({ className: "card--requirements__body" }, { children: [_jsx(FontAwesomeIcon, { className: "enabled", icon: faMicrophone }, void 0), _jsx("span", { children: t('MICROPHONE.MICROPHONE_ENABLED') }, void 0)] }), void 0)] }), void 0)), _jsx("div", Object.assign({ className: "label label--blue" }, { children: t('MICROPHONE.REQUIREMENTS_DESCRIPTION_AUDIO') }), void 0), _jsxs("div", Object.assign({ className: "button-group mt-5" }, { children: [_jsx(Button, { className: [ButtonStyle.Secondary, ButtonStyle.Outline], title: t('GENERAL.GO_BACK'), onClick: () => navigate('/welcome') }, void 0), _jsx(Button, { title: t('GENERAL.CONTINUE'), onClick: () => {
                                    setGoToTakeExam(true);
                                    localStorage.setItem('goToTakeExam', 'true');
                                }, disabled: !isReadyToStart }, void 0)] }), void 0)] }), void 0)), goToTakeExam && children] }, void 0));
};
export default MicrophoneRoute;
